import React from "react";

import { Box } from "@mui/material";

interface SpacerProps {
  h?: number;
  w?: number;
}

export const Spacer: React.FC<SpacerProps> = ({ h, w }) => {
  return <Box height={h} width={w} />;
};
